const Styles = {
  logoStyle: {
    width: "65%",
  },
  container: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    height: "100%",
    overflowY: "auto",
  },

  gridStyle: {
    display: "flex",
    alignItems: "center",
    marginBottom: 20,
    marginLeft: 45,
    cursor: "pointer",
  },

  listItemTextStyle: {
    color: "#fff",
  },

  listItemButton: {
    minHeight: 48,
    px: 2.5,
    color: "#fff",
    paddingLeft: "3rem",
  },

  listItemTextPrimary: {
    color: "#183053",
  },

  listItemIcon: {
    minWidth: 0,
    justifyContent: "center",
    color: "#183053",
  },

  boxPrimary: {
    display: "flex",
    height: "100%",
    overflow: "hidden",
  },
  main: {
    flexGrow: 1,
    background: "#F7F7F9",
    width: "81%",
    position: "relative",
    zIndex: 1200,
    height: "100vh",
  },
  boxDrawerStickyHeader: {
    background: "#F7F7F9",
    position: "sticky",
    top: 0,
    left: 0,
    zIndex: 50,
  },
  wrapper: {
    backgroundColor: "#fff",
    height: "calc(100vh - 95px)",
    overflowY: "scroll",
  },
  outletContainer: {
    backgroundColor: "#FFF",
    margin: "1rem",
  },
  card: {
    boxShadow: "0px 2px 16px rgba(0, 0, 0, 0.1)",
    borderRadius: "8px",
    padding: "2rem",
  },
  table: {
    padding: "10px 15px",
  },
  memberStyles: {
    paddingLeft: "2rem",
    margin: "4px 16px",
    borderRadius: "8px",
    display: "flex",
    textDecoration: "none",
  },
  activeMember: {
    background:
      "linear-gradient(270deg, #0F1490 -42%, #1C22BD 34.92%, #F02731 100%)",
  },
  memberIconStyle: {
    fontSize: "small",
    color: "#183053",
    marginRight: "6px",
  },
  fontMedium: { fontSize: "16px" },
  listItemContainer: {
    textDecoration: "none",
    display: "flex",
    alignItems: "center",
    width: "100%",
  },

  // Menubar style
  listContainer: {
    padding: "1rem 0rem 1rem 0rem",
  },
  link: {
    textDecoration: "none",
    cursor: "pointer",
    display: "block",
    color: "#183053",
    margin: "0 0.6rem 0 1rem",
  },
  linkMobile: {
    textDecoration: "none",
    cursor: "pointer",
    display: "block",
    color: "#183053",
    margin: "0 0.6rem 0 0rem",
  },
  activeLink: {
    backgroundColor: "#043D90",
    color: "white",
    borderRadius: 8,
  },
  navContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "5px 5px 5px 5px",
    margin: "6px 0",
    borderRadius: "6px",
    fontWeight: "700",
    letterSpacing: "2px",
  },

  nestedContainer: {
    paddingLeft: "5px",
    gap: 0,
    cursor: "pointer",
    margin: "4px 0",
    borderRadius: "4px",
    fontWeight: "500",
    letterSpacing: "0px",
  },

  hover: {
    "&:hover": {
      background: "#CCE1FF",
      borderRadius: "8px",
    },
  },
  icon: {
    display: "flex",
    alignItems: "center",
    color: "white",
    flex: 1,
  },
  dot: {
    width: 8,
    height: 8,
    borderRadius: "50%",
    backgroundColor: "#8C8C8C",
  },
  title: {
    display: "flex",
    fontSize: 14,
    alignItems: "center",
    color: "inherit",
    flex: 4,
  },

  expandArrow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    flex: 0.4, // 👈️ bring arrow closer
  },
  collapse: {
    padding: "0 0.6rem 0 1rem",
  },
  settingIcon: {
    color: "#8c8c8c",
    width: "18px",
    height: "18px",
  },
  navContainerMobile: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "0.6rem 0.8rem",
    borderRadius: "6px",
  },
  nestedContainerMobile: {
    paddingLeft: "0.8rem",
    gap: 10,
    cursor: "pointer",
  },
  // Menubar style Mobile
  listContainerMobile: {
    padding: "0rem 0rem 1rem 0rem",
  },
};
export default Styles;
